export const VALIDATION_LEDGER_GET_LIST_ACTION = 'VALIDATION_LEDGER_GET_LIST_ACTION'
export const VALIDATION_LEDGER_EXPORT_ACTION = 'VALIDATION_LEDGER_EXPORT_ACTION'
export const VALIDATION_LEDGER_UNSET_EXPORT_ACTION = 'VALIDATION_LEDGER_UNSET_EXPORT_ACTION'
export const VALIDATION_LEDGER_GET_LOCATION_DETAILS = 'VALIDATION_LEDGER_GET_LOCATION_DETAILS'
